module.exports = __webpack_public_path__ + "static/media/certificate_icon.7288d62e.svg";